import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductDescription extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      this.dataset.productId != null &&
      event.target.dataset.productId != null &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const blockId = this.dataset.blockId;
    if (!blockId) return;

    const selector = `product-description[data-block-id="${CSS.escape(blockId)}"]`;
    const newRoot = event.detail.data.html.querySelector(selector);
    if (!newRoot) return;

    morph(this, newRoot, { childrenOnly: true });
  };
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription);
}
